import 'babel-polyfill';
// ReSharper disable once UnusedLocals (Used by ReactDOM)
import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, Redirect, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { OidcProvider } from 'redux-oidc';
import moment from 'moment';
import { datadogRum } from '@datadog/browser-rum';

import 'moment/min/locales.min';
import axios from './utils/axios';
import Callback from './containers/Callback/CallbackContainer';
import SignIn from './containers/SignIn/SignInContainer';
import injectHistoryIntoStore from './store/communityStore';
import persistTransform from './store/transforms/persistTransform';
import globals from './globals/communityGlobals';
import { userManager, processUser } from './utils/userManager';
import './utils/formsy';
import routes from './settings/routeSettings';

window.entryPoint = () => {
  const { basename, apiUrl } = globals.urls;
  axios.defaults.baseURL = apiUrl;
  moment.locale(globals.momentLocale);
  const history = createBrowserHistory({ basename });
  const store = injectHistoryIntoStore(history);

  persistStore(store, { transforms: [persistTransform] }, () => {
    processUser(store, history);

    const dataDog = globals.dataDogSettings;
    if (dataDog.hasDataDogConfig) {
      datadogRum.init({
        applicationId: dataDog.applicationId,
        clientToken: dataDog.clientToken,
        site: dataDog.site,
        service: dataDog.service,
        env: dataDog.env,
        version: dataDog.version,
        sampleRate: 100,
        trackInteractions: true,
      });
    }

    ReactDOM.render(
      <Provider store={store}>
        <OidcProvider store={store} userManager={userManager}>
          <ConnectedRouter history={history}>
            <Switch>
              <Redirect exact from="/" to="/SignIn" />
              <Route path="/SignIn" render={props => <SignIn pageTitle="Login" {...props} />} />
              <Route path="/Callback" component={Callback} />
              {routes}
            </Switch>
          </ConnectedRouter>
        </OidcProvider>
      </Provider>,
      document.querySelector('app'),
    );
  });
};
